// extracted by mini-css-extract-plugin
export default {"icon":"IconMentors_icon__wUQeS","iconSelected":"IconMentors_iconSelected__I4459"};